import { useStyle } from '@/classify';
import Button from '@/components/Button';
import Field from '@/components/Field';
import FormError from '@/components/FormError/formError';
import GoogleRecaptcha from '@/components/GoogleReCaptcha';
import Password from '@/components/Password';
import TextInput from '@/components/TextInput';
import { GET_CART_DETAILS_QUERY } from '@/hooks/SignIn/signIn.gql';
import { useSignIn } from '@/hooks/SignIn/useSignIn';
import { isRequired, validateEmail } from '@/util/formValidators';
import { Form } from 'informed';
import { useIntl } from 'react-intl';
import defaultClasses from './trackOrderSignIn.module.css';

const TrackOrderSignIn = props => {
  const classes = useStyle(defaultClasses, props.classes);

  const {
    setDefaultUsername = () => {},
    showCreateAccount = () => {},
    showForgotPassword = () => {},
    afterSubmit,
    initialValues,
  } = props;

  const { formatMessage } = useIntl();
  const talonProps = useSignIn({
    getCartDetailsQuery: GET_CART_DETAILS_QUERY,
    setDefaultUsername,
    showCreateAccount,
    afterSubmit,
    showForgotPassword,
  });

  const { errors, handleSubmit, isBusy, loading, recaptchaWidgetProps } = talonProps;

  return (
    <div className={classes.root}>
      <FormError errors={Array.from(errors.values())} />
      <Form
        className={classes.form}
        onSubmit={handleSubmit}
        initialValues={initialValues && initialValues}
      >
        <Field
          id='email'
          label={formatMessage({
            id: 'signIn.emailText',
            defaultMessage: 'Email',
          })}
          classes={{
            requiredLabel: classes.requiredLabel,
          }}
          required
        >
          <TextInput
            id='email'
            autoComplete='email'
            field='email'
            validate={value => {
              return validateEmail(typeof value === 'string' ? value.trim() : value);
            }}
          />
        </Field>
        <div className={classes.passwordContainer}>
          <div className={classes.passwordHeader}>
            <label className={classes.passwordLabel}>Password</label>
          </div>
          <Password
            data-cy='SignIn-password'
            fieldName='password'
            id='Password'
            required
            validate={isRequired}
            autoComplete='current-password'
            isToggleButtonHidden={false}
            aria-label={formatMessage({
              id: 'global.passwordRequired',
              defaultMessage: 'Password Required',
            })}
          />
        </div>

        <GoogleRecaptcha {...recaptchaWidgetProps} />
        <Button
          priority='high'
          className={classes.signInButton}
          type='submit'
          disabled={isBusy}
          loading={loading}
        >
          Login
        </Button>
      </Form>
    </div>
  );
};

export default TrackOrderSignIn;
